const FIELDS = ["kind", "message", "options", "next_key", "wait", "condition", "action", "updates", "capture", "ui", "list_button", "list_footer"];
const META = ["name", "enabled", "trigger_type", "trigger_value", "triggers", "priority", "start_key", "folder", "favorite"];

const norm = (v) => {
  if (v === null || v === undefined || v === "" || (Array.isArray(v) && !v.length)) return null;
  if (Array.isArray(v)) return v.map(norm);
  if (typeof v === "object") {
    const o = {};
    Object.keys(v).sort().forEach((k) => { const n = norm(v[k]); if (n !== null) o[k] = n; });
    return Object.keys(o).length ? o : null;
  }
  return v;
};
const sig = (obj, keys) => JSON.stringify(keys.map((k) => norm(obj?.[k])));

// Confronto locale tra il flusso sul canvas e l'ultima versione salvata
export function computeFlowDiff(current, savedObj) {
  const cur = new Map((current?.steps || []).map((s) => [s.key, s]));
  const old = new Map((savedObj?.steps || []).map((s) => [s.key, s]));
  const added = new Set(), modified = new Set(), removed = [];
  cur.forEach((s, k) => { if (!old.has(k)) added.add(k); else if (sig(s, FIELDS) !== sig(old.get(k), FIELDS)) modified.add(k); });
  old.forEach((s, k) => { if (!cur.has(k)) removed.push(s); });
  const meta = META.filter((k) => JSON.stringify(norm(current?.[k])) !== JSON.stringify(norm(savedObj?.[k])));
  const total = added.size + modified.size + removed.length + meta.length;
  return { added, modified, removed, meta, total };
}
